import ChangeSubscriptionModal from 'modals/ChangeSubscriptionModal/ChangeSubscriptionModal'

export default ChangeSubscriptionModal
